import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Layout from "./components/Layout";

import ConsumerStations from "./pages/consumer/Stations";
import StationDetail from "./pages/consumer/StationDetail";
import ConsumerSessions from "./pages/consumer/Sessions";
import Wallet from "./pages/consumer/Wallet";
import SessionHistory from "./pages/consumer/History";

import OperatorFleet from "./pages/operator/Fleet";
import OperatorRevenue from "./pages/operator/Revenue";
import OperatorAlerts from "./pages/operator/Alerts";

import SafetyZones from "./pages/safety/Zones";
import EmergencyControl from "./pages/safety/EmergencyControl";
import CriticalDevices from "./pages/safety/CriticalDevices";

import AdminNetwork from "./pages/admin/Network";
import AdminStations from "./pages/admin/Stations";
import AdminUsers from "./pages/admin/Users";
import AdminPolicies from "./pages/admin/Policies";
import AdminAI from "./pages/admin/AI";

import "./App.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-zinc-500 font-mono text-xs">LOADING…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route path="/app" element={<Protected><Layout /></Protected>}>
            <Route index element={<Navigate to="/app/consumer/stations" replace />} />

            <Route path="consumer/stations" element={<ConsumerStations />} />
            <Route path="consumer/stations/:id" element={<StationDetail />} />
            <Route path="consumer/sessions" element={<ConsumerSessions />} />
            <Route path="consumer/wallet" element={<Wallet />} />
            <Route path="consumer/history" element={<SessionHistory />} />

            <Route path="operator/fleet" element={<OperatorFleet />} />
            <Route path="operator/revenue" element={<OperatorRevenue />} />
            <Route path="operator/alerts" element={<OperatorAlerts />} />

            <Route path="safety/zones" element={<SafetyZones />} />
            <Route path="safety/emergency" element={<EmergencyControl />} />
            <Route path="safety/critical" element={<CriticalDevices />} />

            <Route path="admin/network" element={<AdminNetwork />} />
            <Route path="admin/stations" element={<AdminStations />} />
            <Route path="admin/users" element={<AdminUsers />} />
            <Route path="admin/policies" element={<AdminPolicies />} />
            <Route path="admin/ai" element={<AdminAI />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
